import React, { useEffect, useState } from 'react'
import ClientModel from './models/ClientModel';
import axios from 'axios';
import moment from 'moment';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getStorageValues } from '../../shared/CommonFunctions';

function ViewClient(props) {
  const [clientData, setClientData] = useState(new ClientModel());
  const [getShowTitle, setShowTitle] = useState(false);
  const [clientInvestmentData, setclientInvestmentData] = useState([]);

  useEffect(() => {
    setClientData(props.ClientData);
    if(props.ClientData.TaxStatus === "Individual"){
      setShowTitle(true);
    }
    const fetchClientInvestments = async () => {
      try {
        let ClientDetails = {
          UserId: getStorageValues('userId'),
          ClientId: props.ClientData.ClientId
        };
        const response = await axios.get(getApiBaseUrl() + "/clientinvestments", {
          params: ClientDetails
        });
        if (response.status === 200) {
          setclientInvestmentData(response.data.data[0]);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchClientInvestments();
  }, [props.ClientData])
  return (
    <>
      <div className="row">
        <div className="col-lg-3 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Tax Status</label>
            <input type="text" className="form-control" value={clientData.TaxStatus} disabled />
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Mode of Holding</label>
            <input type="text" className="form-control" value={clientData.ModeOfHolding} disabled />
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Client Ratings</label>
            <input type="text" className="form-control" value={clientData.ClientRating} disabled />
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Refered By</label>
            <input type="text" className="form-control" value={clientData.ReferedBy} disabled />
          </div>
        </div>
      </div>
      <div className="accordion accordion-primary" id="accordionPrimaryExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingPrimaryOne">
            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePrimaryOne" aria-expanded="true" aria-controls="collapsePrimaryOne">
              Personal Detail
            </button>
          </h2>
          <div id="collapsePrimaryOne" className="accordion-collapse collapse show" aria-labelledby="headingPrimaryOne" data-bs-parent="#accordionPrimaryExample">
            <div className="accordion-body">
              <div className="row">
                <div className="col-lg-2 col-sm-6 col-12" style={{ display: getShowTitle === true ? "block" : "none" }}>
                  <div className="mb-3">
                    <label className="form-label">Title</label>
                    <input type="text" className="form-control" value={clientData.Title} disabled />
                  </div>
                </div>
                <div className={getShowTitle === true ? "col-lg-6 col-sm-6 col-12" : "col-lg-12 col-sm-6 col-12"}>
                  <div className="mb-3">
                    <label className="form-label">Client Name</label>
                    <input type="text" className="form-control" value={clientData.ClientName} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12" style={{ display: getShowTitle === true ? "block" : "none" }}>
                  <div className="mb-3">
                    <label className="form-label">Family Head</label>
                    <input type="text" className="form-control" value={clientData.FamilyHeadName} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Gender</label>
                    <input type="text" className="form-control" value={clientData.Gender} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Email Id</label>
                    <input type="text" className="form-control" value={clientData.EmailId} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Mobile No<span style={{ color: "red" }}>*</span></label>
                    <input type="text" className="form-control" value={clientData.MobileNumber} disabled />
                  </div>
                </div>               

                <div className="row">
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <label className="form-label">Date Of Birth</label>
                      <input type="text" className="form-control" value={moment(clientData.DateOfBirth).format('DD/MM/YYYY')} disabled />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <label className="form-label">Date Of Anniversary</label>
                      <input type="text" className="form-control" value={moment(clientData.DateOfAnniversary).format('DD/MM/YYYY')} disabled />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">Place Of Birth</label>
                      <input type="text" className="form-control" value={clientData.PlaceOfBirth} disabled />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">Country Of Birth</label>
                      <input type="text" className="form-control" value={clientData.CountryOfBirth} disabled />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Occupation</label>
                    <input type="text" className="form-control" value={clientData.Occupation} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">PAN Number</label>
                    <input type="text" className="form-control" value={clientData.PANNo} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Nominee</label>
                    <input type="text" className="form-control" value={clientData.Nominee} disabled />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingPrimaryTwo">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePrimaryTwo" aria-expanded="false" aria-controls="collapsePrimaryTwo">
              Address Details
            </button>
          </h2>
          <div id="collapsePrimaryTwo" className="accordion-collapse collapse" aria-labelledby="headingPrimaryTwo" data-bs-parent="#accordionPrimaryExample">
            <div className="accordion-body">
              <div className="row">
              <div className="col-lg-4 col-sm-6 col-12">
                  <div className="input-blocks summer-description-box transfer mb-3">
                    <label>Address #1</label>
                    <textarea
                      className="form-control h-100"
                      name="AddressLine1"
                      rows={3}
                      cols={40} value={clientData.AddressLine1} disabled
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="input-blocks summer-description-box transfer mb-3">
                    <label>Address #2</label>
                    <textarea
                      className="form-control h-100"
                      name="AddressLine2"
                      rows={3}
                      cols={40} value={clientData.AddressLine2} disabled
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="input-blocks summer-description-box transfer mb-3">
                    <label>Address #3</label>
                    <textarea
                      className="form-control h-100"
                      name="AddressLine3"
                      rows={3}
                      cols={40} value={clientData.AddressLine3} disabled
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">City</label>
                    <input type="text" className="form-control" value={clientData.City} disabled />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">State</label>
                    <input type="text" className="form-control" value={clientData.State} disabled />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Country</label>
                    <input type="text" className="form-control" value={clientData.Country} disabled />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Pin No</label>
                    <input type="text" className="form-control" value={clientData.PinNumber} disabled />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingPrimaryThree">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePrimaryThree" aria-expanded="false" aria-controls="collapsePrimaryThree">
              Investment Company/Category
            </button>
          </h2>
          <div id="collapsePrimaryThree" className="accordion-collapse collapse" aria-labelledby="headingPrimaryThree" data-bs-parent="#accordionPrimaryExample">
            <div className="accordion-body">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Client Investment Details</h5>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Company Type</th>
                          <th>Company</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          clientInvestmentData.length === 0 
                          ? clientInvestmentData.map((d, i) => (
                              <tr key={i}>
                                  <td>No Investment to display</td>
                              </tr>
                          )) 
                          : clientInvestmentData.map((d, i) => (
                              <tr key={i}>
                                  <td>{i+1}</td>
                                  <td>{d.ClientCompanyTypeName}</td>
                                  <td>{d.ClientCompanyName}</td>
                              </tr>
                          )) 
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="accordion-item">
          <h2 className="accordion-header" id="headingPrimaryFour">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePrimaryFour" aria-expanded="false" aria-controls="collapsePrimaryFour">
              Other Details
            </button>
          </h2>
          <div id="collapsePrimaryFour" className="accordion-collapse collapse" aria-labelledby="headingPrimaryFour" data-bs-parent="#accordionPrimaryExample">
            <div className="accordion-body">
              <div className="row">
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">DP ID</label>
                    <input type="text" className="form-control" value={clientData.DPId} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">NPS A/C No</label>
                    <input type="text" className="form-control" value={clientData.NPSAccountNumber} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Annual Income</label>
                    <input type="text" className="form-control" value={clientData.AnnualIncome} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Gross Annual Income</label>
                    <input type="text" className="form-control" value={clientData.GrossAnnualIncome} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Net Worth</label>
                    <input type="text" className="form-control" value={clientData.NetWorth} disabled />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Bank Name</label>
                    <input type="text" className="form-control" value={clientData.BankName} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Branch Name</label>
                    <input type="text" className="form-control" value={clientData.BranchName} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">Account No</label>
                    <input type="text" className="form-control" value={clientData.AccountNumber} disabled />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3">
                    <label className="form-label">IFSC Code</label>
                    <input type="text" className="form-control" value={clientData.IFSCCode} disabled />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewClient